module.exports = __webpack_public_path__ + "static/media/feature-channels.ac4ad750.svg";